module.exports = __webpack_public_path__ + "img/events-3.f2178da6.png";